/**
 * Checkbox Recipe - Modern Chakra UI v3 Implementation
 */

import { defineRecipe } from '@chakra-ui/react';

export const checkboxRecipe = defineRecipe({
  className: 'checkbox',

  base: {
    _focusVisible: {
      outline: '2px solid',
      outlineColor: 'text.info',
      outlineOffset: '2px',
    },
  },

  variants: {
    variant: {
      default: {
        // Uses default Chakra styling
      },
      green: {
        _checked: {
          bg: 'background.accent',
          borderColor: 'border.accent.active',
          _hover: {
            bg: 'green.hover',
            borderColor: 'green.hover',
          },
        },
      },
    },
    size: {
      sm: {
        w: '16px',
        h: '16px',
      },
      md: {
        w: '20px',
        h: '20px',
      },
      lg: {
        w: '24px',
        h: '24px',
      },
    },
  },

  defaultVariants: {
    variant: 'green',
    size: 'md',
  },
});
